import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, PhoneIcon, ShieldCheckIcon, LayoutDashboardIcon, ArrowRightIcon } from 'lucide-react';
export function HowItWorks({
  onOpenQuote
}: {
  onOpenQuote?: () => void;
}) {
  const steps = [{
    title: 'Bill Auditors',
    eyebrow: 'TELECOM EXPENSE SPECIALISTS',
    desc: 'We analyze every line item on your telecom bills to uncover hidden fees, billing errors, and overcharges that cost your business thousands each year.',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=600&fit=crop'
  }, {
    title: 'Rate Negotiators',
    eyebrow: 'EXCLUSIVE PROVIDER ACCESS',
    desc: "We leverage relationships with every major carrier to negotiate rates your business can't get on its own. We guarantee the most competitive pricing available.",
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=600&fit=crop'
  }, {
    title: 'Cost Optimizers',
    eyebrow: 'ONGOING EXPENSE REDUCTION',
    desc: "We don't just find savings once — we continuously monitor your telecom spend, flag cost creep, and recommend adjustments to keep your expenses as low as possible.",
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop'
  }];
  return <section className="py-24 bg-white overflow-hidden" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        {/* Section Title */}
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#011B33]" data-id="element-188">
            How it Works
          </h2>
          <div className="w-20 h-1.5 bg-[#22A39F] mx-auto mt-6 rounded-full" data-id="element-189"></div>
        </div>

        {/* Top Row: 3 Large Vertical Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20" data-id="element-190">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="relative rounded-[2.5rem] bg-[#F5F7F8] border border-slate-100 flex flex-col overflow-hidden group hover:border-[#22A39F]/30 transition-all shadow-sm hover:shadow-xl" data-id="element-191">
              <div className="h-56 overflow-hidden" data-id="element-192">
                <img src={step.image} alt={step.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-193" />
              </div>
              <div className="p-10 flex flex-col items-start" data-id="element-194">
                <div className="text-[10px] font-bold text-[#22A39F] uppercase tracking-[0.2em] mb-4" data-id="element-195">
                  {step.eyebrow}
                </div>
                <h3 className="text-2xl font-bold text-[#011B33] mb-4" data-id="element-196">
                  {step.title}
                </h3>
                <p className="text-slate-500 leading-relaxed" data-id="element-197">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Middle Row: Icon Strip */}
        <div className="flex flex-wrap justify-center items-center gap-12 md:gap-24 mb-24 py-12 border-y border-slate-100" data-id="element-198">
          {[{
          icon: GlobeIcon,
          label: 'Internet'
        }, {
          icon: PhoneIcon,
          label: 'VoIP'
        }, {
          icon: ShieldCheckIcon,
          label: 'Security'
        }, {
          icon: LayoutDashboardIcon,
          label: 'Website/CRM'
        }].map((item, i) => <div key={i} className="flex items-center gap-4 group" data-id="element-199">
              <div className="w-12 h-12 rounded-xl bg-[#011B33] flex items-center justify-center text-[#22A39F] group-hover:scale-110 transition-transform" data-id="element-200">
                <item.icon className="w-6 h-6" data-id="element-201" />
              </div>
              <span className="text-sm font-bold text-[#011B33] uppercase tracking-widest" data-id="element-202">
                {item.label}
              </span>
            </div>)}
        </div>

        {/* Final CTA */}
        <div className="flex justify-center" data-id="element-203">
          <button onClick={onOpenQuote} className="bg-[#22A39F] hover:bg-[#1d8a87] text-white px-12 py-5 rounded-2xl font-bold text-xl transition-all shadow-xl shadow-[#22A39F]/20 flex items-center gap-3 group" data-id="element-204">
            Get Started Now
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-205" />
          </button>
        </div>
      </div>
    </section>;
}